import api from './api';

export const listarPeriodos = async () => {
  const response = await api.get('/periodos');
  return response.data;
};

export const obterPeriodo = async (id) => {
  const response = await api.get(`/periodos/${id}`);
  return response.data;
};

export const criarPeriodo = async (periodoData) => {
  const response = await api.post('/periodos', periodoData);
  return response.data;
};

export const atualizarPeriodo = async (id, periodoData) => {
  const response = await api.put(`/periodos/${id}`, periodoData);
  return response.data;
};

export const excluirPeriodo = async (id) => {
  const response = await api.delete(`/periodos/${id}`);
  return response.data;
};

export const listarPeriodosPorCampanha = async (campanhaId) => {
  const response = await api.get(`/periodos/campanha/${campanhaId}`);
  return response.data;
};